module.exports = __webpack_public_path__ + "img/vu.2615664.svg";